import React from 'react';

import awardsBg from '../../assets/img/awards/awards-style1-bg.png';
import awardIcon1 from '../../assets/img/icons/award-icon-1.png';
import awardIcon2 from '../../assets/img/icons/award-icon-2.png';
import googleIcon from '../../assets/img/icons/awards-google.png';
import leftWings from '../../assets/img/awards/award-box-left-wings.png';
import rightWings from '../../assets/img/awards/award-box-right-wings.png';

const Awards = () => {
    const awards = [
        {
            id: 1,
            title: "World Travelers Award",
            category: "WORLD TRAVEL",
            year: "2023",
            description: "Received in happy award in",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 132 103" fill="none">
                    <path d="M113.179 31.5771L114.345 33.9106C118.132 41.484 124.273 47.6249 131.846 51.4116H113.179V31.5771Z" fill="#667eea" />
                    <path d="M18.668 31.5771L17.5012 33.9106C13.7145 41.484 7.57363 47.6249 0.000244141 51.4116H18.668V31.5771Z" fill="#667eea" />
                    <circle cx="51.1642" cy="51.1642" r="47.1642" transform="matrix(1 0 0 -1 14.7588 102.328)" fill="#667eea" stroke="#667eea" strokeWidth="8" />
                    <circle cx="67.5308" cy="51.5308" r="39.2808" fill="#FFD166" stroke="#FFD166" strokeWidth="1.5" strokeDasharray="3 3" />
                    <path d="M80.5531 52.3525C81.4013 52.3525 82.2165 52.1074 82.9353 51.6249C84.1269 50.8194 84.954 49.3584 84.9862 47.8389C85.0231 47.0666 84.9862 46.2485 84.8733 45.337C84.8099 44.8155 84.3504 44.4116 83.7586 44.4703C82.747 44.6005 81.7104 45.0807 80.8462 45.8325C80.8054 45.496 80.7517 45.1621 80.6848 44.831C81.6436 44.3561 82.3848 43.5933 82.768 42.6415C83.3234 41.3088 83.1493 39.6629 82.3118 38.3458C81.8458 37.6114 81.3439 36.9373 80.8216 36.34C80.4587 35.9266 79.8323 35.8838 79.417 36.2467C78.5162 37.0336 77.9092 38.1756 77.6612 39.5588C77.4369 40.8865 77.6114 42.006 78.113 43.219C80.1978 48.1718 78.2832 53.8349 73.9463 56.6012C73.6393 56.7928 73.3967 57.0576 73.2307 57.3658H68.996V53.2966L72.5017 55.1169C72.8445 55.294 73.2485 55.2557 73.5464 55.038C73.8518 54.8163 74.0056 54.4418 73.9433 54.0692L73.1117 49.0654L76.7254 45.5061C76.9939 45.2415 77.0902 44.8475 76.9734 44.4895C76.8567 44.1306 76.5474 43.868 76.1748 43.8115L71.1827 43.0598L68.9074 38.0298C68.5845 37.3158 67.4152 37.3158 67.0923 38.0298L64.817 43.0598L59.8249 43.8117C59.4524 43.8682 59.143 44.1308 59.0263 44.4897C58.9096 44.8477 59.0059 45.2417 59.2744 45.5063L62.8881 49.0656L62.0564 54.0694C61.9941 54.4419 62.1478 54.8165 62.4533 55.0382C62.7588 55.26 63.1615 55.2902 63.498 55.1171L67.0038 53.2968V57.366H62.7378C62.369 56.7477 61.8054 56.4673 61.2775 56.0547C58.4798 53.7922 57.0624 50.5337 57.0624 47.4051C57.0624 43.4278 58.8985 42.7963 58.3552 39.5473C58.1071 38.1748 57.5011 37.0337 56.6013 36.2468C56.1899 35.8849 55.5576 35.9258 55.1967 36.3402C54.6704 36.9413 54.1685 37.6164 53.7065 38.3449C52.869 39.662 52.6929 41.3079 53.2444 42.6308C53.6317 43.5915 54.3747 44.3563 55.3344 44.8317C55.2674 45.163 55.2138 45.4971 55.173 45.8339C54.3059 45.0807 53.2514 44.6004 52.2409 44.4704C51.9783 44.4421 51.7117 44.5093 51.5026 44.6727C51.2935 44.8351 51.1573 45.0754 51.1262 45.3381C51.0143 46.2505 50.9783 47.0695 51.0123 47.8225C51.0542 49.3973 51.9107 50.8622 53.0916 51.6327C53.7833 52.1094 54.6013 52.3535 55.4564 52.3535C55.6558 52.3535 55.8583 52.3294 56.0608 52.3027C56.1869 52.6104 56.3131 52.9174 56.4619 53.2147C55.5658 53.0989 54.4449 53.1272 53.3474 53.6715C52.8413 53.9226 52.6488 54.5387 52.9078 55.0285C53.257 55.6929 53.6733 56.4605 54.1684 57.1306C55.0122 58.3623 56.3999 59.2094 58.0389 59.2094C59.0305 59.2094 59.9837 58.8294 60.7703 58.1474C60.8923 58.2345 61.0069 58.3201 61.0272 58.3622V65.3348H60.0311C59.4805 65.3348 59.035 65.7803 59.035 66.3309C59.035 66.8815 59.4805 67.327 60.0311 67.327H75.9685C76.5191 67.327 76.9646 66.8815 76.9646 66.3309C76.9646 65.7803 76.5191 65.3348 75.9685 65.3348H74.9724V58.4692C74.9844 58.4074 75.0103 58.3495 75.0103 58.2852C75.088 58.2356 75.1552 58.1747 75.2315 58.1237C77.3039 59.9518 80.2379 59.3905 81.8731 57.1365C82.3402 56.4252 82.7961 55.7483 83.1483 54.9838C83.374 54.4945 83.1688 53.9138 82.6853 53.6745C81.7762 53.2242 80.7443 53.092 79.5527 53.2383C79.7071 52.9318 79.8592 52.6239 79.9889 52.3051C80.1778 52.3288 80.3668 52.3525 80.5531 52.3525ZM69.9921 63.3425H66.0077C65.4571 63.3425 65.0116 62.897 65.0116 62.3464C65.0116 61.7958 65.4571 61.3503 66.0077 61.3503H69.9921C70.5426 61.3503 70.9881 61.7958 70.9881 62.3464C70.9881 62.897 70.5426 63.3425 69.9921 63.3425Z" fill="#667eea" />
                </svg>
            )
        },
        {
            id: 2,
            title: "Tours Adventures Award",
            category: "TRAVEL AWARD",
            year: "2024",
            description: "Received in happy award in",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 132 103" fill="none">
                    <path d="M113.179 31.5771L114.345 33.9106C118.132 41.484 124.273 47.6249 131.846 51.4116H113.179V31.5771Z" fill="#667eea" />
                    <path d="M18.668 31.5771L17.5012 33.9106C13.7145 41.484 7.57363 47.6249 0.000244141 51.4116H18.668V31.5771Z" fill="#667eea" />
                    <circle cx="51.1642" cy="51.1642" r="47.1642" transform="matrix(1 0 0 -1 14.7588 102.328)" fill="#667eea" stroke="#667eea" strokeWidth="8" />
                    <circle cx="67.5308" cy="51.5308" r="39.2808" fill="#FFD166" stroke="#FFD166" strokeWidth="1.5" strokeDasharray="3 3" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M70.1325 38.2514C68.1798 37.1867 65.8201 37.1867 63.8675 38.2514L53.4108 43.9532C51.3083 45.0997 50 47.3032 50 49.6981V60.4675C50 62.8623 51.3083 65.0659 53.4108 66.2123L63.8675 71.9141C65.8201 72.9787 68.1798 72.9787 70.1325 71.9141L80.5892 66.2123C82.6918 65.0659 84 62.8623 84 60.4675V49.6981C84 47.3032 82.6918 45.0997 80.5892 43.9532L70.1325 38.2514ZM67.0005 48.5395C66.3808 48.5395 65.9664 49.2828 65.1376 50.7696L64.9232 51.1544C64.6878 51.5769 64.5701 51.788 64.3864 51.9274C64.2028 52.0667 63.9742 52.1187 63.5168 52.222L63.1004 52.3163C61.4909 52.6805 60.6862 52.8624 60.4947 53.4781C60.3033 54.0939 60.8519 54.7353 61.9491 56.0185L62.233 56.3504C62.5448 56.7149 62.7006 56.8972 62.7709 57.1228C62.8409 57.3483 62.8173 57.5915 62.7702 58.0781L62.7272 58.5208C62.5614 60.2328 62.4785 61.0887 62.9796 61.4693C63.481 61.8497 64.2344 61.5029 65.7413 60.809L66.1311 60.6295C66.5594 60.4324 66.7734 60.3338 67.0005 60.3338C67.2275 60.3338 67.4415 60.4324 67.8699 60.6295L68.2596 60.809C69.7665 61.5029 70.5199 61.8497 71.0213 61.4693C71.5226 61.0887 71.4395 60.2328 71.2737 58.5208L71.2307 58.0781C71.1836 57.5915 71.1601 57.3483 71.2301 57.1228C71.3003 56.8972 71.4562 56.7149 71.7679 56.3504L72.0519 56.0185C73.149 54.7353 73.6978 54.0939 73.5063 53.4781C73.3148 52.8624 72.5099 52.6805 70.9005 52.3163L70.4841 52.222C70.0268 52.1187 69.7982 52.0667 69.6145 51.9274C69.4309 51.788 69.3131 51.5769 69.0778 51.1544L68.8633 50.7696C68.0345 49.2828 67.6201 48.5395 67.0005 48.5395Z" fill="#667eea" />
                    <path d="M64.8191 30H69.1814C73.294 30 75.3504 30 76.6281 31.2777C77.9058 32.5553 77.9058 34.6117 77.9058 38.7244V38.7636L71.6986 35.379C68.7696 33.7819 65.2301 33.7819 62.3011 35.379L56.0947 38.7631V38.7244C56.0947 34.6117 56.0947 32.5553 57.3724 31.2777C58.65 30 60.7064 30 64.8191 30Z" fill="#667eea" />
                </svg>
            )
        },
        {
            id: 3,
            title: "Travel Adventure Award",
            category: "TRAVEL AWARD",
            year: "2025",
            description: "Received in happy award in",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 132 103" fill="none">
                    <path d="M113.179 31.5771L114.345 33.9106C118.132 41.484 124.273 47.6249 131.846 51.4116H113.179V31.5771Z" fill="#667eea" />
                    <path d="M18.668 31.5771L17.5012 33.9106C13.7145 41.484 7.57363 47.6249 0.000244141 51.4116H18.668V31.5771Z" fill="#667eea" />
                    <circle cx="51.1642" cy="51.1642" r="47.1642" transform="matrix(1 0 0 -1 14.7588 102.328)" fill="#667eea" stroke="#667eea" strokeWidth="8" />
                    <circle cx="67.5308" cy="51.5308" r="39.2808" fill="#FFD166" stroke="#FFD166" strokeWidth="1.5" strokeDasharray="3 3" />
                    <path d="M51.6644 46.8563L60.6171 62.9798C60.8081 66.9046 64.0328 70.0656 68 70.0656C71.9672 70.0656 75.2131 66.9046 75.3828 62.9798L84.3356 46.8563C85.4812 44.7985 85.1206 42.189 83.4446 40.5342L77.2286 34.3182C77.0376 34.1273 76.6982 34 76.486 34H59.514C59.3018 34 58.9624 34.1273 58.7714 34.3182L52.5554 40.5342C50.8794 42.2102 50.5188 44.7985 51.6644 46.8563ZM68.0212 67.9441C65.0935 67.9441 62.7174 65.568 62.7174 62.6404C62.7174 59.7127 65.0935 57.3366 68.0212 57.3366C70.9489 57.3366 73.325 59.7127 73.325 62.6404C73.325 65.568 70.9489 67.9441 68.0212 67.9441ZM63.6509 42.486L62.8023 40.3645H73.2401L72.3915 42.486H63.6509ZM71.5429 44.6075L68.0212 53.4118L64.4995 44.6075H71.5429ZM78.3742 41.8708C78.6288 41.3404 79.2652 41.1071 79.7956 41.3616C80.326 41.6162 80.5593 42.2527 80.3047 42.783L74.2372 55.6606C73.9827 56.191 73.3462 56.4243 72.8158 56.1698C72.2854 55.9152 72.0521 55.2787 72.3067 54.7484L78.3742 41.8708ZM74.9373 36.1215L74.0887 38.243H61.9537L61.1051 36.1215H74.9373ZM56.2468 41.3616C56.7772 41.1071 57.4137 41.3404 57.6683 41.8708L63.7358 54.7484C63.9903 55.2787 63.757 55.9152 63.2266 56.1698C62.6962 56.4243 62.0598 56.191 61.8052 55.6606L55.7377 42.783C55.4831 42.2527 55.7165 41.6162 56.2468 41.3616Z" fill="#667eea" />
                    <path d="M68.0217 59.458C67.4277 59.458 66.9609 59.9247 66.9609 60.5188C66.9609 61.1128 67.4277 61.5795 68.0217 61.5795C68.6157 61.5795 69.0824 62.0462 69.0824 62.6403C69.0824 63.2343 69.5492 63.701 70.1432 63.701C70.7372 63.701 71.204 63.2343 71.204 62.6403C71.204 60.8794 69.7825 59.458 68.0217 59.458Z" fill="#667eea" />
                </svg>
            )
        }
    ];

    const AwardCard = ({ award }) => (
        <div style={{
            background: '#ffffff',
            borderRadius: '20px',
            padding: '40px 30px',
            textAlign: 'center',
            boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
            border: '1px solid rgba(0,0,0,0.05)',
            height: '380px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            transition: 'transform 0.3s ease'
        }}>
            <div>
                <div style={{
                    width: '80px',
                    height: '80px',
                    margin: '0 auto 25px',
                    color: '#f7bd34ff'
                }}>
                    {award.icon}
                </div>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    marginBottom: '20px'
                }}>
                    <img src={leftWings} alt="wings" style={{ width: '30px' }} />
                    <h3 style={{
                        margin: 0,
                        fontSize: '18px',
                        fontWeight: '700',
                        color: '#333',
                        lineHeight: '1.3'
                    }}>
                        {award.title}
                    </h3>
                    <img src={rightWings} alt="wings" style={{ width: '30px' }} />
                </div>
                <div style={{
                    background: '#f7bd34ff',
                    color: 'white',
                    padding: '10px 25px',
                    borderRadius: '25px',
                    fontSize: '12px',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    display: 'inline-block',
                    marginBottom: '20px',
                    letterSpacing: '1.5px'
                }}>
                    {award.category}
                </div>
            </div>
            <p style={{
                margin: 0,
                color: '#666',
                fontSize: '15px',
                fontWeight: '500'
            }}>
                {award.description} <strong style={{ color: '#333', fontSize: '16px' }}>{award.year}</strong>
            </p>
        </div>
    );

    return (
        <section style={{
            padding: '80px 0',
            backgroundImage: `url(${awardsBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center'
        }}>
            <img 
                src={awardIcon1} 
                alt="icon" 
                style={{
                    position: 'absolute',
                    top: '10%',
                    left: '5%',
                    width: '80px',
                    opacity: 0.7
                }}
            />
            <img 
                src={awardIcon2} 
                alt="icon" 
                style={{
                    position: 'absolute',
                    bottom: '10%',
                    right: '5%',
                    width: '80px',
                    opacity: 0.7
                }}
            />

            <div className="container" style={{
                position: 'relative',
                zIndex: 2
            }}>
               
                <div style={{
                    textAlign: 'center',
                    marginBottom: '60px'
                }}>
                    <span style={{
                        display: 'block',
                        color: '#f7bd34ff',
                        fontSize: '18px',
                        marginBottom: '15px',
                        textTransform: 'uppercase',
                        letterSpacing: '3px',
                        fontWeight: '800'
                    }}>
                        DISCOVER ORGANIZED
                    </span>
                    <h2 style={{
                        fontSize: '48px',
                        fontWeight: '700',
                        color: 'black',
                        lineHeight: '1.2',
                        margin: '0 0 10px 0'
                    }}>
                        Tours And Adventures
                    </h2>
                    <h3 style={{
                        fontSize: '36px',
                        fontWeight: '300',
                        color: 'black',
                        opacity: 0.9,
                        margin: '0'
                    }}>
                        Our Awards
                    </h3>
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: '30px',
                    alignItems: 'stretch',
                    marginBottom: '50px'
                }}>
                    {awards.map((award) => (
                        <AwardCard key={award.id} award={award} />
                    ))}
                </div>

                <div style={{
                    display: 'flex',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '20px',
                        padding: '30px 40px',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                        border: '1px solid rgba(0,0,0,0.05)',
                        maxWidth: '400px',
                        width: '100%',
                        textAlign: 'center'
                    }}>
                       
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '15px',
                            marginBottom: '25px'
                        }}>
                            <img src={googleIcon} alt="Google" style={{ width: '45px' }} />
                            <div style={{ textAlign: 'left' }}>
                                <strong style={{
                                    display: 'block',
                                    fontSize: '20px',
                                    color: '#333',
                                    fontWeight: '700',
                                    marginBottom: '2px'
                                }}>Google</strong>
                                <span style={{
                                    display: 'block',
                                    fontSize: '12px',
                                    color: '#666',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1.5px'
                                }}>REVIEWED BY</span>
                            </div>
                        </div>

                        
                        <div style={{
                            background: 'linear-gradient(135deg, #232f66ff, #232f66ff)',
                            borderRadius: '15px',
                            padding: '25px',
                            color: 'white'
                        }}>
                            <div style={{
                                fontSize: '36px',
                                fontWeight: '700',
                                marginBottom: '8px'
                            }}>4.5</div>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '3px',
                                marginBottom: '10px'
                            }}>
                                {[...Array(5)].map((_, i) => (
                                    <span key={i} style={{ color: '#FFD700', fontSize: '20px' }}>★</span>
                                ))}
                            </div>
                            <div style={{
                                fontSize: '14px',
                                opacity: 0.9,
                                fontWeight: '500'
                            }}>8.5K reviews</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Awards;